import vars from '../vars';
import { formItemPartials } from './form/form-item';
import { newFormItemPartials } from './newForm/new-form-item';

const partials = {
  focus: `box-shadow: 0px 0px 4px 1px ${vars.newColor.blue2};`,
  form: {
    item: formItemPartials,
  },
  newForm: {
    item: newFormItemPartials,
  },
};

export default partials;
